export default "__VITE_ASSET__DymJ2MMF__"